/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
var moment = require('moment');

window.Vue = require('vue').default;
import { Lang } from 'laravel-vue-lang';

import Vuex from 'vuex';
import 'es6-promise/auto';
import "bootstrap-vue/dist/bootstrap-vue.css";



//--require('bootstrap-slider'); //if app_helios.js => not need, without app_helios.js => need
import bFormSlider from 'vue-bootstrap-slider';
Vue.use(bFormSlider)



/*
  Adds the promise polyfill for IE 11

require('es6-promise').polyfill();
*/
Vue.use(Vuex);

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts';

window.Highcharts = Highcharts;




// load these modules as your need
import loadStock from 'highcharts/modules/stock.js';
import exportingInit from 'highcharts/modules/exporting.js';
import exportingInitOff from 'highcharts/modules/offline-exporting.js';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';


/*import stockInit from 'highcharts/modules/stock'
stockInit(Highcharts)
Vue.use(VueHighcharts) */

loadStock(Highcharts);
exportingInit(Highcharts);
exportingInitOff(Highcharts);
HighchartsNoData(Highcharts);

Vue.use(VueHighcharts, { Highcharts });

//--import Vue from 'vue'
import iframeResize from 'iframe-resizer/js/iframeResizer';
Vue.use(iframeResize);

Vue.directive('resize', {
    bind: function (el, { value = {} }) {
        el.addEventListener('load', () => iframeResize(value, el))
    },
    unbind: function (el) {
        el.iFrameResizer.removeListeners();
    }
})


import VueRouter from 'vue-router'
Vue.use(VueRouter);

import "friendly-challenge/widget";

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/*Vue.component('example-component', require('./components/ExampleComponent.vue').default);*/
Vue.component('main-page', require('./components/MainPage.vue').default);
//--Vue.component('operatingpoint', require('./components/OperatingPoint.vue').default);
Vue.component('product-detail', require('./components/ProductDetail.vue').default);
Vue.component('sticky-header', require('./components/StickyHeader.vue').default);
Vue.component('float-actionbutton', require('./components/FloatActionButton.vue').default);
Vue.component('footercomponent', require('./components/FooterComponent.vue').default);
Vue.component('newsletterlanding', require('./components/NewsletterLanding.vue').default);


import MainPage from './components/MainPage.vue';
import ProductDetail from './components/ProductDetail.vue';


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.use(Lang, {
    /* locale: 'de', */
    fallback: 'de',
});



import store from './store';




/*
const store = new Vuex.Store({
    state: {

    },

})
*/
/*
const router = new VueRouter({
    hashbang: false,
    history: true,
    linkActiveClass: "active",
    routes: [{
        path: '/:locale(de|en|fr)?',
        component: {
            beforeRouteEnter: setLocale,
            beforeRouteUpdate: setLocale,
            render(h) { return h('router-view'); }
        },
    }],
})
router.mode = 'html5'
function setLocale(to, from, next) {
    let { locale } = to.params;
    if (!locale) {
        locale = 'de';
    }

    // Do something with locale, check availability of messages etc.
    i18n.locale = locale;
    next();

}
*/
//window._locale = 'de';


const router = new VueRouter({
    hash: false,
    mode: "history",
    base: '',//`/${window._country}-${window._locale}/`,//`/${window.navigator.language}/`,//`/${window._locale}/`,

    /* routes: [
        {
            path: '/:language(de|en|fr)?',
            component: MainPage
        },
        {
            name: 'productdetail',
            //path: '/get/test/product',
            path: '/get/product',
            component: ProductDetail
        },

    ], */

    routes: [
        {
            path: `/${window._country}-${window._locale}/`,//':language(de|en|fr|ru|un|tr|pl)?', ///:language(de|en|fr|ru|un|tr|pl)?
            children: [
                {
                    path: '',
                    component: MainPage
                },
                {
                    name: 'productdetail',
                    path: 'get/product',
                    component: ProductDetail
                },

            ]
        }
    ]

});

const app = new Vue({
    el: '#app',
    store: store,
    router: router,
});



